angular.module('env.data.services.gridTextSearch', [])

    .run(function (gridTextSearchService) {
        gridTextSearchService.fixGridTextSearchConfig();
    })

    .service('gridTextSearchService', function (omqlAliasBuilder, gridTextSearchConfigService, userSettings, authService, orderItemsRepository, ordersRepository) {

        var _this = this;

        var ordersCFDefs = [];
        var orderItemCFDefs = [];

        authService.events.on([
            'login',
            'continueSessionAfterReload'
        ], function () {
            ordersRepository.getCustomFieldDefinitions().then(function (defs) {
                ordersCFDefs = defs;
            });
            orderItemsRepository.getCustomFieldDefinitions().then(function (defs) {
                orderItemCFDefs = defs;
            });
        });

        _.extend(_this, {
            getCriteria: getCriteria,
            fixGridTextSearchConfig: fixGridTextSearchConfig
        });

        return _this;

        function getCriteria(searchText, exactMatch) {
            var aliasStack = [];
            var criteria = [];

            if (!searchText) {
                return $q.when(criteria);
            }

            return userSettings.getSettings().then(function(settings) {
                _.iterateTree(settings.gridSettings.textSearchFields, "items", function (el) {
                    var pattern;

                    if (el.alias) {
                        aliasStack.push(el.alias);
                    }

                    if (el.checked && (!el.items || el.items.length <= 0)) {

                        if (el.customFields) {
                            pattern = exactMatch ? "%s = '%s'" : "%s LIKE '%%%s%%'";
                            var cfDefs = [];
                            var as = "";
                            if (el.customFields == "Order") {
                                cfDefs = ordersCFDefs;
                                as = "Order.";
                            } else if (el.customFields == "OrderItem") {
                                cfDefs = orderItemCFDefs;
                                as = "OrderItem.";
                            }
                            _.forEach(cfDefs, function (def) {
                                if (def && def.code) {
                                    criteria.push(_.str.sprintf(pattern, as + def.code, searchText));
                                }
                            });
                            return;
                        }

                        if (aliasStack.length > 0) {

                            if (el.pattern && _.isString(el.pattern) && el.pattern.length > 2) {
                                pattern = el.pattern;
                            } else if (el.type == "date") {
                                if (exactMatch) {
                                    pattern = "%s LIKE '%%%s%%'";
                                }
                            } else if (el.type == "int") {
                                if (/^\+?(0|[1-9]\d*)$/.test(searchText)) {
                                    pattern = exactMatch ? "%s = '%s'" : "%s LIKE '%%%s%%'";
                                }
                            } else {
                                pattern = exactMatch ? "%s = '%s'" : "%s LIKE '%%%s%%'";
                            }

                            if (pattern) {
                                criteria.push(_.str.sprintf(pattern, aliasStack.join("."), searchText));
                            }
                        }
                    }
                },
                    function (el) {
                        if (el.alias) {
                            aliasStack.pop();
                        }
                    }
                );
                return criteria;
            });
        }

        // preserve user old settings
        function fixGridTextSearchConfig() {
            userSettings.getSettings().then(function(settings) {
                if (!settings.gridSettings) {
                    settings.gridSettings = {};
                }

                if (!settings.gridSettings.textSearchFields || _.isEqual({}, settings.gridSettings.textSearchFields)) {
                    settings.gridSettings.textSearchFields = gridTextSearchConfigService.getDefaultConfig();
                }

                _.iterateTree(settings.gridSettings.textSearchFields,
                    "items",
                    function (el) {
                        if (el.items && el.items.length <= 0) {
                            delete el.items;
                        }
                    });

                userSettings.save();
            });
        }
    })

    .service('gridTextSearchConfigService', function () {

        var _this = this;

        _this.getDefaultConfig = function () {
            return [mapOrderItem()];
        };

        return _this;

        //region map methods

        function mapOrderItem() {
            return {
                text: 'Order Item',
                checked: true,
                expanded: true,
                items: [
                    {
                        text: 'Id',
                        alias: 'OrderItem.Id',
                        type: 'int',
                        checked: true
                    },
                    {
                        text: 'Data',
                        alias: 'OrderItem.Data',
                        checked: true
                    },
                    {
                        text: 'Completed',
                        alias: 'OrderItem.Completed',
                        type: 'date',
                        checked: true
                    },
                    {
                        text: 'Expected by',
                        alias: 'OrderItem.ExpectedBy',
                        type: 'date',
                        checked: true
                    },
                    {
                        text: 'Required by',
                        alias: 'OrderItem.RequiredBy',
                        type: 'date',
                        checked: true
                    },
                    {
                        text: 'Summary',
                        alias: 'OrderItem.Summary',
                        checked: true
                    },

                    {
                        text: 'Custom fields',
                        customFields: 'OrderItem',
                        checked: true
                    },

                    {
                        text: 'Step',
                        alias: 'Step.Code',
                        checked: true
                    },
                    {
                        text: 'Assigned Centre',
                        checked: true,
                        items: [
                            {
                                text: 'Code',
                                alias: 'AssignedCentre.Code',
                                checked: true
                            },
                            mapAddress('Address', 'AssignedCentreAddress')
                        ]
                    },
                    {
                        text: 'Created By',
                        alias: 'CreatedBy',
                        checked: true,
                        items: [
                            {
                                text: 'Name',
                                alias: 'Name',
                                checked: true
                            },
                            {
                                text: 'Last name',
                                alias: 'LastName',
                                checked: true
                            },
                            {
                                text: 'First name',
                                alias: 'FirstName',
                                checked: true
                            },
                            {
                                text: 'Title',
                                alias: 'Title',
                                checked: true
                            },
                            {
                                text: 'Email',
                                alias: 'Email',
                                checked: true
                            }
                        ]
                    },

                    {
                        text: 'Order',
                        checked: true,
                        items: [
                            {
                                text: 'Id',
                                alias: 'Order.Id',
                                type: 'int',
                                checked: true
                            },
                            {
                                text: 'Reference',
                                alias: 'Order.Reference',
                                checked: true
                            },
                            {
                                text: 'Summary',
                                alias: 'Order.Summary',
                                checked: true
                            },
                            {
                                text: 'Data',
                                alias: 'Order.Data',
                                checked: true
                            },
                            {
                                text: 'Completed',
                                alias: 'Order.Completed',
                                type: 'date',
                                checked: true
                            },
                            {
                                text: 'Expected by',
                                alias: 'Order.ExpectedBy',
                                type: 'date',
                                checked: true
                            },
                            {
                                text: 'Required by',
                                alias: 'Order.RequiredBy',
                                type: 'date',
                                checked: true
                            },
                            {
                                text: 'Custom fields',
                                customFields: 'Order',
                                checked: true
                            },
                            {
                                text: 'Centre',
                                checked: true,
                                items: [
                                    {
                                        text: 'Code',
                                        alias: 'Centre.Code',
                                        checked: true
                                    },
                                    mapAddress('Address', 'CentreAddress')
                                ]
                            },
                            {
                                text: 'Customer',
                                items: [
                                    {
                                        text: 'Code',
                                        alias: 'Customer.Code',
                                        checked: true
                                    },
                                    mapAddress('Address', 'CustomerAddress')
                                ]
                            },
                            mapAddress('Delivery address', 'DeliveryAddress')
                        ]
                    }

                ]
            };
        }

        function mapAddress(text, alias) {
            return {
                text: text,
                alias: alias,
                checked: true,
                items: [
                    {
                        text: 'Line 1',
                        alias: 'Line1',
                        checked: true
                    },
                    {
                        text: 'Line 2',
                        alias: 'Line2',
                        checked: true
                    },
                    {
                        text: 'City',
                        alias: 'City',
                        checked: true
                    },
                    {
                        text: 'Company Name',
                        alias: 'CompanyName',
                        checked: true
                    },
                    {
                        text: 'Contact last name',
                        alias: 'ContactLastName',
                        checked: true
                    },
                    {
                        text: 'Contact first name',
                        alias: 'ContactFirstName',
                        checked: true
                    },
                    {
                        text: 'Contact title',
                        alias: 'ContactTitle',
                        checked: true
                    },
                    {
                        text: 'Country',
                        alias: 'Country',
                        checked: true
                    },
                    {
                        text: 'Email',
                        alias: 'Email',
                        checked: true
                    },
                    {
                        text: 'Postal code',
                        alias: 'PostalCode',
                        checked: true
                    },
                    {
                        text: 'Region',
                        alias: 'Region',
                        checked: true
                    },
                    {
                        text: 'Telephone',
                        alias: 'Telephone',
                        checked: true
                    }
                ]
            };
        }

        //function mapCentre(text, alias) {
        //    return {
        //        text: text,
        //        alias: alias,
        //        items: [
        //            {
        //                text: 'Code',
        //                alias: 'Code'
        //            },
        //            mapAddress('Address', 'Address')
        //        ]
        //    };
        //}
        //
        //function mapCustomer(text, alias) {
        //    return {
        //        text: text,
        //        alias: alias,
        //        items: [
        //            {
        //                text: 'Code',
        //                alias: 'Code'
        //            },
        //            mapAddress('Address', 'Address'),
        //            mapCentre('Centre', 'Centre')
        //        ]
        //    };
        //}
        //
        //function mapStep(text, alias) {
        //    return {
        //        text: text,
        //        alias: alias,
        //        items: [
        //            {
        //                text: 'Code',
        //                alias: 'Code'
        //            }
        //        ]
        //    };
        //}
        //
        //function mapOrder(text, alias) {
        //    return {
        //        text: text,
        //        alias: alias,
        //        items: [
        //            {
        //                text: 'Id',
        //                alias: 'Id',
        //                type: 'int'
        //            },
        //            {
        //                text: 'Reference',
        //                alias: 'Reference'
        //            },
        //            {
        //                text: 'Summary',
        //                alias: 'Summary'
        //            },
        //            {
        //                text: 'Data',
        //                alias: 'Data'
        //            },
        //            {
        //                text: 'Completed',
        //                alias: 'Completed',
        //                type: 'date'
        //            },
        //            {
        //                text: 'Expected by',
        //                alias: 'ExpectedBy',
        //                type: 'date'
        //            },
        //            {
        //                text: 'Required by',
        //                alias: 'RequiredBy',
        //                type: 'date'
        //            },
        //            mapCentre('Centre', 'Centre'),
        //            mapCustomer('Customer', 'Customer'),
        //            mapAddress('Delivery address', 'DeliveryAddress'),
        //            mapUser('Created by', 'CreatedBy')
        //        ]
        //    };
        //}
        //
        //function mapOrderItem(text, alias) {
        //    return {
        //        text: text,
        //        expanded: true,
        //        alias: alias,
        //        items: [
        //            {
        //                text: 'Id',
        //                alias: 'Id',
        //                type: 'int'
        //            },
        //            {
        //                text: 'Data',
        //                alias: 'Data'
        //            },
        //            {
        //                text: 'Completed',
        //                alias: 'Completed',
        //                type: 'date'
        //            },
        //            {
        //                text: 'Expected by',
        //                alias: 'ExpectedBy',
        //                type: 'date'
        //            },
        //            {
        //                text: 'Required by',
        //                alias: 'RequiredBy',
        //                type: 'date'
        //            },
        //            {
        //                text: 'Summary',
        //                alias: 'Summary'
        //            },
        //            mapOrder('Order', 'Order'),
        //            mapStep('Step', 'Step'),
        //            mapCentre('Assigned centre', 'AssignedCentre'),
        //            mapUser('Created by', 'CreatedBy')
        //        ]
        //    };
        //}
        //
        //function mapUser(text, alias) {
        //    return {
        //        text: text,
        //        alias: alias,
        //        items: [
        //            {
        //                text: 'Name',
        //                alias: 'Name'
        //            },
        //            {
        //                text: 'Last name',
        //                alias: 'LastName'
        //            },
        //            {
        //                text: 'First name',
        //                alias: 'FirstName'
        //            },
        //            {
        //                text: 'Title',
        //                alias: 'Title'
        //            },
        //            {
        //                text: 'Email',
        //                alias: 'Email'
        //            }
        //        ]
        //    }
        //}

        //endregion
    })

;
